import {
  Chart as ChartJS,
  DoughnutController,
  Element,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js'

/**
 * パーセント表示用のプラグイン
 */
export const percentagePlugin = {
  id: 'percentagePlugin',
  afterDraw(chart: ChartJS) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (!chart.options.plugins?.showPercentage) return

    const { ctx } = chart
    const dataset = chart.data.datasets[0]

    if (!dataset) return

    const total: number = dataset.data.reduce((sum: number, value) => {
      if (typeof value === 'number') {
        return sum + value
      }
      return sum
    }, 0)

    ctx.save()
    ctx.font = 'bold 12px Noto Sans JP'
    ctx.fillStyle = '#000'
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'

    chart.getDatasetMeta(0).data.forEach((arc: Element, index: number) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const arcEl = arc as any
      const value = dataset.data[index]

      // 0または数値以外は表示しない
      if (typeof value !== 'number' || value === 0) return

      const centerAngle = (arcEl.startAngle + arcEl.endAngle) / 2
      const radius = (arcEl.innerRadius + arcEl.outerRadius) / 2 + 25 // 30px外側にオフセット
      const x = arcEl.x + Math.cos(centerAngle) * radius
      const y = arcEl.y + Math.sin(centerAngle) * radius

      const percent = `${((value / total) * 100).toFixed(0)}%`
      ctx.fillText(percent, x, y)
    })

    ctx.restore()
  }
}

// 使用するコントローラ・要素・プラグインを登録
export const registerChart = (): void => {
  ChartJS.register(DoughnutController, ArcElement, Tooltip, Legend, percentagePlugin)
}
